<template>
    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :ColonneWidth="['25%', '25%', '25%', '25%']" :GetFunction="getPickupPointLocationlist">
        <template v-slot:Filter0>
            <ColumnFilter :title="$t('suppliers.locationTab.headers.name')" :Filter="FieldName"
                :getList="getPickupPointLocationlist" @cancel="FieldName = null">
                <template v-slot:input>
                    <v-text-field v-model="FieldName" id="FieldName" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:Filter1>
            <ColumnFilter :title="this.$t('suppliers.locationTab.headers.country')" :Filter="FieldCountry"
                :getList="getPickupPointLocationlist" @cancel="FieldCountry = null">
                <template v-slot:input>
                    <v-text-field v-model="FieldCountry" id="FieldCountry" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:Filter2>
            <ColumnFilter :title="$t('suppliers.locationTab.headers.city')" :Filter="FieldCity"
                :getList="getPickupPointLocationlist" @cancel="FieldCity = null">
                <template v-slot:input>
                    <v-text-field v-model="FieldCity" id="FieldCity" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:Filter3>
            <ColumnFilter :title="$t('suppliers.locationTab.headers.postalCode')" :Filter="FieldPostalCode"
                :getList="getPickupPointLocationlist" @cancel="FieldPostalCode = null">
                <template v-slot:input>
                    <v-text-field v-model="FieldPostalCode" id="FieldPostalCode" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:item0="{ item }">{{ item.locationName }}</template>
        <template v-slot:item1="{ item }">{{ item.country }}</template>
        <template v-slot:item2="{ item }">{{ item.city }}</template>
        <template v-slot:item3="{ item }">{{ item.postalCode }}</template>
        <template v-slot:edit="{ item, index }">
            <PickupPointActionMenu :Id="index" :PickupPoint="item"
                :getPickupPointLocationlist="getPickupPointLocationlist" />
        </template>
    </gridComponent>
</template>
<script>
import gridComponent from "@/genericComponent/gridComponent.vue";
import PickupPointActionMenu from "./PickupPointActionMenu.vue";
import { getPickupPointLocationlist } from "@/api/index"
import ColumnFilter from "@/genericComponent/ColumnFilter.vue";
export default {
    name: "PickupPointLocationsTab",
    components: { PickupPointActionMenu, gridComponent, ColumnFilter },
    data() {
        return {
            loader: true,
            page: 1,
            PageSize: 10,
            itemsData: {},
            items: [],
            search: null,
            FieldName: null,
            FieldAddress: null,
            FieldCity: null,
            FieldPostalCode: null,
            FieldCountry: null,
            SortedBy: "",
            SortingType: ""
        };
    },
    mounted() {
        this.emitter.off('event-test')
        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.search = event;
            this.getPickupPointLocationlist();
        })
    },
    unmounted() {
        this.emitter.off('event-test')
        this.emitter.emit('remise-search-at-null');
    },
    methods: {
        getPickupPointLocationlist: function (page) {
            if (page) { this.page = page }
            getPickupPointLocationlist(this.page, this.PageSize, this.FieldName == null ? this.search : this.FieldName,
                this.FieldAddress, this.FieldCity, this.FieldPostalCode, this.FieldCountry, this.SortedBy, this.SortingType).then((response) => {
                    this.items = response.data.items
                    this.itemsData.numberOfPage = response.data.totalPages;
                    this.itemsData.totalItemsCount = response.data.totalCount;
                    this.itemsData.pageNumber = response.data.pageNumber;
                    this.itemsData.hasPreviousPage = response.data.hasPreviousPage
                    this.itemsData.hasNextPage = response.data.hasNextPage
                    this.loader = false;
                })
        }
    },
    computed: {
        headers() {
            return [
                this.$t('suppliers.locationTab.headers.name'),
                this.$t('suppliers.locationTab.headers.country'),
                this.$t('suppliers.locationTab.headers.city'),
                this.$t('suppliers.locationTab.headers.postalCode')
            ]
        },
    }
};
</script>